import React, { FunctionComponent } from 'react';
import { withRouter, match, Link } from 'react-router-dom';
import { Container, Grid } from 'semantic-ui-react';
import { pathOr } from 'ramda';
import { compose } from 'recompose';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

import CardStatusSection from 'components/CardStatusSection';
import { GET_MERCHANT_CARD_NETWORK_STATUS } from 'components/CardStatusSection/CardStatusSection.queries';
import { Theme } from 'config';

import { Merchant } from '../MerchantDetails/MerchantDetails';

import MerchantCNTransactions from './sections/MerchantCNTransactions';
import MerchantCNStatusPanel from './sections/MerchantCNStatusPanel';

const styles = (theme: Theme) => ({
  container: {
    margin: '2.25rem auto !important',
    height: '100% !important',
  },
  header: {
    display: 'flex !important',
    paddingTop: '1.875em !important',
  },
  headerText: {
    color: '#440C7F !important',
  },
  link: {
    marginLeft: 'auto !important',
  },
  grid: {
    margin: '0 !important',
  },
  gridRow: {
    padding: '0 !important',
  },
  button: {
    margin: '1rem .75rem !important',
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.8rem !important',
    padding: '0.5rem 1.25rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.25rem !important',

    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
});

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  match: match;
  merchant: Merchant;
};

const defaultErrorMessage = {
  displayMessage: 'Something went wrong',
  message: 'Not enough data to display at this time.',
};

const MerchantNetworkHealth: FunctionComponent<Props> = ({
  classes,
  match,
  merchant,
}) => {
  const merchantId: string = pathOr('', ['params', 'merchantId'], match);
  if (!merchantId || merchantId === 'null') {
    throw new Error(JSON.stringify([defaultErrorMessage]));
  }
  return (
    <Container className={classes.container}>
      <CardStatusSection
        query={GET_MERCHANT_CARD_NETWORK_STATUS}
        params={{
          merchantId,
        }}
      />

      <Grid className={classes.grid}>
        <Grid.Row className={classes.gridRow} centered textAlign="center">
          <Link className={classes.button} to="/network-health">
            Get Card Network IDs
          </Link>
        </Grid.Row>
      </Grid>

      <MerchantCNStatusPanel
        match={match}
        merchantId={merchantId}
        merchant={merchant}
      />

      <MerchantCNTransactions merchantId={merchantId} />
    </Container>
  );
};

export default compose(
  withRouter,
  withStyles(styles),
)(MerchantNetworkHealth as any);
